module.exports = __webpack_public_path__ + "54ccaa26d7e70d449b5bfc1dbedca456.png";